import { render, staticRenderFns } from "./ModeOfCommunications.vue?vue&type=template&id=17531c82&"
import script from "./ModeOfCommunications.vue?vue&type=script&lang=js&"
export * from "./ModeOfCommunications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports